import React from 'react';
import Button from './Button';

const ResetButton = (props) => <Button htmlType="reset" {...props} />;

export default ResetButton;
